import {Component, effect, OnInit} from '@angular/core';
import {StorageService} from "@cybfed/core/services/storage.service";
import {MeService} from "@cybfed/core/services/me.service";
import {UserStore} from "@cybfed/core/store/user.store";
import {Router} from "@angular/router";
import {RedirectAnimationComponent} from "@cybfed/shared/components/redirect-animation/redirect-animation.component";

@Component({
    selector: 'app-redirect',
    standalone: true,
    imports: [
        RedirectAnimationComponent

    ],
    providers: [
        MeService
    ],
    templateUrl: './redirect.component.html',
    styleUrl: './redirect.component.scss'
})
export class RedirectComponent implements OnInit {


    constructor(
        private meService: MeService,
        private userStore: UserStore,
        private router: Router,
    ) {
        this.getTokenFromUrl()
    }

    ngOnInit(): void {

    }
    getTokenFromUrl() {
        if (typeof window === 'undefined') {
            return; // Skip execution in SSR
        }
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('authToken');

        if (token) {
            // Store token in local storage
            StorageService.setItem(StorageService.statics.token, token);
            this.getProfileData('adminPanel')
        }
    }
    getProfileData(redirect: string){
        this.meService.getProfile().subscribe((data: any)=>{
            if (!data.hasError) {
                StorageService.setJsonItem(StorageService.statics.currentUser, {...data.data?.account, ...{userId: data.data?.account._id}});
                StorageService.setJsonItem(StorageService.statics.profileData, data.data?.account)
                StorageService.setItem(StorageService.statics.currency, data.data?.account.currency)
                this.userStore.currentUser = data.data?.account;
                if(redirect === 'adminPanel'){
                    setTimeout(() => {
                        this.router.navigate([`/admin`]);
                    }, 100)

                }
            }
        })
    }
}
